exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".open-link-1 {\r\n  fill: #586671\r\n}", ""]);
